import React, { useEffect } from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
} from "@mui/material";
import Moment from "react-moment";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import Loader from "../../../shared/components/Loader";
import ActionToast from "../../../shared/components/ActionToast";
import Table from "../../../shared/components/tables/Table";
import SortTableHead, { TableColumnDefinition } from "../../../shared/components/SortTableHead";
import TablePagination from "../../../shared/components/tables/TablePagination";
import { AdminLeadsState } from "../../models/AdminLeadsModels";
import { changeQuery, getLeads, setSuccess } from "../../adminLeadsSlice";

const Leads = () => {
  const { query, leads, loading, success, error } = useAppSelector<AdminLeadsState>(
    (state: any) => state.adminLeads
  );
  const dispatch = useAppDispatch();

  const columns: TableColumnDefinition[] = [
    { title: "Email" },
    { title: "Created" }
  ];

  const handlePageSizeChange = async (size: number) => {
    const newQuery = { ...query, pageNo: 1, pageSize: size };
    await dispatch(changeQuery(newQuery));
    dispatch(getLeads(newQuery));
  };

  const handlePageNoChange = async (no: number) => {
    const newQuery = { ...query, pageNo: no };
    await dispatch(changeQuery(newQuery));
    dispatch(getLeads(newQuery));
  };

  useEffect(() => {
    dispatch(getLeads(query));
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <ActionToast
        open={!!success}
        variant="success"
        message={success || ""}
        onClose={() => dispatch(setSuccess(undefined))}
        duration={6000}
      />

      <Toolbar className="flex items-center justify-between w-full">
        <div className="flex items-center">
          <p className="heading-2">Leads</p>
        </div>
      </Toolbar>

      <Table className="px-3 v-fill">
        <SortTableHead columns={columns} sortBy={query.sortBy} sortDesc={query.sortDesc} onSort={() => { }} />

        <TableBody>
          {leads?.items?.map((lead, index) => (
            <TableRow key={index}>
              <TableCell>{lead.email}</TableCell>

              <TableCell sx={{ minWidth: "140px" }}>
                <Moment date={lead.createdDate} format="DD.MM.YYYY HH:mm" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        variant="bottom"
        pageNo={query.pageNo}
        pageSize={query.pageSize}
        totalCount={leads?.totalCount}
        onPageNoChange={handlePageNoChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </>
  );
};

export default Leads;